import { startOfToday } from 'date-fns';

import getDateMonthAndYear from './getDateMonthAndYear';
import { Month } from '../types';

export default function getCurrentYearMonthAndDate(): Month {
  return getDateMonthAndYear(startOfToday());
}
